import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './button';
import { Card, CardContent } from './card';

const PermissionAlert = ({ 
  isOpen, 
  onClose, 
  permissionName, 
  pageName,
  redirectTo = '/dashboard' 
}) => {
  if (!isOpen) return null;

  const handleRedirect = () => {
    window.location.href = redirectTo;
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full bg-white border-red-200 shadow-xl">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                <AlertTriangle className="w-6 h-6 text-red-600" />
              </div>
            </div>
            
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Access Denied
              </h3>
              
              <p className="text-sm text-gray-600 mb-4">
                You don't have permission to access <span className="font-medium text-gray-900">"{pageName}"</span>. 
                Please contact your administrator for <span className="font-medium text-red-600">"{permissionName}"</span> permission.
              </p>
              
              <div className="flex gap-3">
                <Button 
                  onClick={handleRedirect}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-900"
                >
                  Go to Dashboard
                </Button>
                <Button 
                  onClick={onClose}
                  variant="outline"
                  className="flex-1"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PermissionAlert;
